'use strict';

angular.module('adelementAdminApp')
    .controller('ExcludedFieldController', function ($scope, $state, ExcludedField, ParseLinks) {

        $scope.excludedFields = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.page = 1;
        $scope.loadAll = function() {
            ExcludedField.query({page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.excludedFields = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.excludedField = {
                entityName: null,
                fieldName: null,
                role: null,
                id: null
            };
        };
    });
